module.exports = __webpack_public_path__ + "annualreview2018/static/img/ukpn-annual-review-2018@2x.4ee2ae2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/covers/ukpn-annual-review-2018@2x.png
// module id = RaE7
// module chunks = 10